import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
/**
 * Shared "must be logged in" gate for /exhibitions, /exhibitions/:id and
 * /societies/:id (see each page's own load()) - every one of their own API
 * calls (SocietyResource's Index/Show endpoints in particular) is
 * ->authenticated(), so a guest visiting any of these directly (a
 * bookmark, a shared link, a search result) previously just saw the
 * page's own generic "impossible de charger" error placeholder,
 * indistinguishable from a real failure.
 *
 * Opens LogInModal right on the current URL rather than navigating
 * anywhere - core's own LogInModal does a plain `window.location.reload()`
 * on a successful login (see its own onsubmit()), so simply staying put
 * and showing the modal already reloads back into this exact page once
 * logged in, no separate "redirect back after login" plumbing needed.
 *
 * LogInModal itself is never a plain top-level import anywhere, even in
 * core (every core call site - HeaderSecondary, IndexSidebar,
 * DiscussionControls - opens it via a lazily-loaded reference to that same
 * component instead, resolved fresh each time it's actually needed rather
 * than captured once up front) - confirmed directly: a static top-level
 * import of it from this extension resolved to `undefined`, since nothing
 * had loaded that lazy chunk yet on a guest's very first page.
 * `app.modal.show()` itself accepts exactly this async-factory shape (see
 * ModalManagerState.show()'s own `AsyncModalClass` branch) - resolving it
 * this same lazy way here, at prompt time rather than module-load time, is
 * what actually triggers flarum.reg's own chunk-loading path (registered
 * via addChunkModule(), confirmed in the compiled bundle) instead of a
 * stale synchronous lookup.
 *
 * setTimeout is required, not incidental: app.modal.show()'s own docs call
 * out that calling it from a lifecycle method like oninit needs this exact
 * wrapping, due to how Mithril handles nested redraws - each of this
 * gate's three call sites (ExhibitionsListPage/ExhibitionPage/SocietyPage's
 * own oninit()) does exactly that, so it's wrapped once here rather than
 * relying on every caller to remember it (confirmed the hard way: without
 * this, dismissing the auto-opened modal threw "Node is currently being
 * rendered to and thus is locked" and further Mithril errors). Harmless
 * from the placeholder button's own onclick below too - a plain event
 * handler doesn't need the deferral, but one extra tick there is
 * unnoticeable.
 */
export function promptLogin() {
  setTimeout(() => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal')));
}

/**
 * The gated page's own placeholder + explicit "Se connecter" button, for
 * when a guest dismisses the auto-opened modal (promptLogin() above)
 * without logging in - same "Placeholder text, but page-specific" shape
 * every other empty/error state on these three pages already uses, just
 * with a real call to action instead of a dead end.
 */
export function loginRequiredPlaceholder(text) {
  return m("div", {
    className: "Placeholder"
  }, m("p", null, text), m(Button, {
    className: "Button Button--primary",
    onclick: promptLogin
  }, app.translator.trans('core.forum.log_in.submit_button')));
}
flarum.reg.add('champis-exhibitions', 'forum/utils/requireLogin', { promptLogin: promptLogin,loginRequiredPlaceholder: loginRequiredPlaceholder, });